import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { Loader } from "@/shared/ui/Loader";
import { cn } from "@/shared/lib/utils";
import styles from "./ImageWithLoader.module.scss";
/**
 * `<img>` с крутяшкой на время загрузки: пока картинка не догрузилась, поверх
 * показывается спиннер — пользователь видит, что идёт загрузка, а не «зависон».
 * Прозрачная замена обычному `<img>`: все пропсы (`src`, `alt`, `className`,
 * `onError` и т.п.) прокидываются как есть.
 *
 * Оверлей позиционируется `position: absolute; inset: 0`, поэтому РОДИТЕЛЬ должен
 * быть позиционированным (`position: relative`) — как большинство обёрток
 * превью/обложек (`.thumb16x9` и т.п.). Без `src` лоадер не показываем.
 *
 * Кэш: если картинка уже в кэше, `onLoad` может не сработать (событие уже
 * прошло) — поэтому после монтирования проверяем `img.complete`.
 */
export const ImageWithLoader = ({ loaderSize = "md", overlayClassName, onLoad, onError, src, ...rest }) => {
    const imgRef = useRef(null);
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        // Сброс при смене src + мгновенная отметка уже закэшированной картинки.
        setLoaded(false);
        const img = imgRef.current;
        if (img && img.complete && img.naturalWidth > 0) {
            setLoaded(true);
        }
    }, [src]);
    const showLoader = Boolean(src) && !loaded;
    return (_jsxs(_Fragment, { children: [showLoader && (_jsx("span", { className: cn(styles.overlay, overlayClassName), "aria-hidden": true, children: _jsx(Loader, { size: loaderSize }) })), _jsx("img", { ref: imgRef, src: src, onLoad: (e) => {
                    setLoaded(true);
                    onLoad?.(e);
                }, onError: (e) => {
                    // Ошибка — снимаем лоадер (иначе крутится вечно); показ ошибки/фолбэка
                    // остаётся за вызывающим кодом через переданный onError.
                    setLoaded(true);
                    onError?.(e);
                }, ...rest })] }));
};
